<script>
import { inject } from 'vue'
import { mapState, mapActions } from 'vuex'
import { debug } from '../js/modules/util'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

export default {
  name: 'AppHeader',

  setup () {
    const shopifyData = inject('shopifyData')
    return { shopifyData }
  },

  data () {
    return {
      headerElement: null,
      isHidden: false,
      menuIsOpen: false
    }
  },

  computed: {
    ...mapState({ headerIsHidden: 'headerIsHidden' }),

    toggleButtonLabel () {
      return this.menuIsOpen ? 'Close menu' : 'Open menu'
    }
  },

  watch: {
    menuIsOpen (isOpen) {
      const items = this.headerElement.querySelectorAll('.menu__list-item')
      // let completedItemsCount = 0

      if (items.length) {
        if (isOpen) {
          document.body.classList.add('menu-is-open')
        } else {
          document.body.classList.remove('menu-is-open')
        }

        // const checkProgress = () => {
        //   completedItemsCount++
        //   debug('checkProgress', completedItemsCount)

        //   if (completedItemsCount === items.length) {
        //     items.forEach((element) => {
        //       element.removeEventListener('transitionend', checkProgress)
        //     })

        //     setTimeout(() => {
        //       this.setHeightVariable()
        //     }, 300)
        //   }
        // }

        // items.forEach((element) => {
        //   element.addEventListener('transitionend', checkProgress)
        // })
      }
    }
  },

  created () {
    this.headerElement = document.querySelector('.header__main')
    this.setHeightVariable()
  },

  mounted () {
    if (this.headerElement) {
      this.init()
    }
  },

  methods: {
    ...mapActions({
      showHeader: 'showHeader',
      hideHeader: 'hideHeader'
    }),

    init () {
      this.initScrollTrigger()
      if (this.shopifyData.templateName === 'collection') {
        this.showActiveShopMenuLink()
      }
      this.bindEvents()
    },
    
    initScrollTrigger () {
      if (this.shopifyData.templateName !== 'index') {
        gsap.registerPlugin(ScrollTrigger)

        ScrollTrigger.create({
          trigger: document.body,
          start: `${getComputedStyle(document.documentElement).getPropertyValue('--height-header')} top`,
          end: 'bottom +=10px',
          toggleClass: 'is-scrolled',
          onUpdate: this.handleScrollUpdate
        })
      }
    },

    showActiveShopMenuLink () {
      const shopMenu = document.querySelector('.menu--shop')
      if (shopMenu) {
        const activeLink = shopMenu.querySelector('.menu__link.is-current')
        if (activeLink) {
          const menuRight = shopMenu.getBoundingClientRect().right
          const activeLinkRight = activeLink.getBoundingClientRect().right
          const rightPadding = getComputedStyle(shopMenu.querySelector('.menu__list')).getPropertyValue('padding-right')
          if (activeLinkRight > menuRight) {
            const x = activeLinkRight - menuRight + parseInt(rightPadding)
            gsap.to(shopMenu, { scrollTo: { x }, duration: 1 })
          }
        }
      }
    },

    handleScrollUpdate ({ direction }) {
      if (direction === -1) {
        this.showHeader()
      } else if (direction === 1 && !this.menuIsOpen) {
        this.hideHeader()
      }
    },

    bindEvents () {
      window.addEventListener('debouncedResize', this.setHeightVariable)
    },

    setHeightVariable () {
      // debug('setHeightVariable', this.headerElement.clientHeight)

      document.documentElement.style.setProperty('--height-header', `${this.headerElement.clientHeight}px`)
    },

    toggleMenu () {
      this.menuIsOpen = !this.menuIsOpen
    }
  }
}
</script>

<template>
  <button
    class="header__menu-toggle t-menu"
    :class="{ 'is-active': menuIsOpen }"
    :title="toggleButtonLabel"
    @click.prevent="toggleMenu"
  >
    <span class="visually-hidden">{{
      toggleButtonLabel
    }}</span>
    <span
      class="header__menu-toggle-icon"
      aria-hidden="true"
    />
  </button>
</template>